import update from 'immutability-helper';
import {
  GET_MY_EVENTS_REQUEST_SUCCESS,
  GET_EVENTS_REQUEST_SUCCESS,
  GET_SINGLE_EVENT_REQUEST_SUCCESS,
  GET_ORG_EVENTS_SUCCESS,
  DELETE_ORG_EVENTS_SUCCESS,
  RESET_EVENT_BY_ID_SUCCESS,
  UPDATE_EVENT_SUCCESS
} from '../constants/actionTypes';

const initialState = {
  allEvents: [],
  myEvents: [],
  singleEvent: {},
  orgEventsList: [],
};

const categories = (state = initialState, action) => {
  switch (action.type) {
    case GET_EVENTS_REQUEST_SUCCESS:
      return {
        ...state,
        allEvents: action.payload.upcomingEvents,
      };
    case GET_MY_EVENTS_REQUEST_SUCCESS:
      return {
        ...state,
        myEvents: action.payload.myEvents,
      };
    case GET_SINGLE_EVENT_REQUEST_SUCCESS:
      return {
        ...state,
        singleEvent: action.payload.event,
      };
    case GET_ORG_EVENTS_SUCCESS:
      return update(state, {
        orgEventsList: {
          $set: action.payload.events,
        },
      });
    case DELETE_ORG_EVENTS_SUCCESS:
      const newEventList = state.orgEventsList.filter((item) => item.id !== action.payload);
      return update(state, {
        orgEventsList: {
          $set: newEventList,
        },
        singleEvent: {
          $set: '',
        }
      });
    case RESET_EVENT_BY_ID_SUCCESS:
      return update(state, {
        singleEvent: {
          $set: '',
        },
      });
    case UPDATE_EVENT_SUCCESS: {
      const eventIndex = (state.orgEventsList || []).findIndex(
        (item) => item.id === action.payload.id,
      );

      if (eventIndex !== -1) {
        const newEventList = [...state.orgEventsList];

        newEventList[eventIndex] = action.payload;

        const newSingleEvent = {
          ...state.singleEvent,
          post: {
            ...state.singleEvent.post,
            ...action.payload,
          }
        };

        return update(state, {
          singleEvent: {
            $set: newSingleEvent,
          },
          orgEventsList: { $set: newEventList },
        });
      } else {
        return update(state, {
          currentCommunity: {
            $set: state.currentCommunity,
          },
          orgEventsList: { $set: state.newEventList },
        });
      }
    }
    default:
      return state;
  }
};

export default categories;
